import { render, staticRenderFns } from "./CambiarPrecio.vue?vue&type=template&id=34b42238"
import script from "./CambiarPrecio.vue?vue&type=script&setup=true&lang=js"
export * from "./CambiarPrecio.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports